import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { PortalService } from '../../../../../core/services/portal.service';
import { Expression } from '../models/expression.model';
import { Intent } from '../models/intent.model';

@Injectable()
export class ExpressionService {
  private loadMoreExp$: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {}

  getExpressions(botId: string, params?: any) {
    return this.http.get<{expressions: Expression[], total: number, status: boolean}>(PortalService.ApiUrl + '/expressions/' + botId, {
      params,
    });
  }

  deleteExpression(expression_id: string) {
    return this.http.delete<any>(PortalService.ApiUrl + '/expression/' + expression_id);
  }

  saveExpression(body: object) {
    return this.http.post<any>(PortalService.ApiUrl + '/expression/training', body);
  }

  searchExpressions(botId: string, params?: any) {
    return this.http.get<{intents: Intent[]}>(PortalService.ApiUrl+ '/intents/' + botId, {
      params,
    });
  }

  testBot(body: object) {
    return this.http.post<{status: boolean, result: any}>(PortalService.ApiUrl + '/expression/parse', body);
  }

  toLoadExpressions() {
    return this.loadMoreExp$;
  }

  setLoadExpressions() {
    this.loadMoreExp$.next();
  }
}
